<template>
    <div class="row content-head bg-col-1">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3 ">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Dealer Role</label>
          <v-select
              placeholder="Select Role"
              v-model="dealerRole"
              :options="companyRules"
              label="name"
              :reduce="name => name.value"
          />
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Dealer/ISC Staff Id</label>
          <input
              name="Referrer Staff Id"
              @input="getDealerIdByStaffId"
              type="text" v-model="dealerIscId"
              class="form-control"
          />
          <transition name="fade">
            <span v-if="dealerIscName" class="fw-bold d-block qcont">Dealer/ISC Staff: {{ dealerIscName }}</span>
          </transition>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="mb-1">
          <label for="colFormLabel" class="col-form-label">Employee Staff</label>
          <input
              type="text" v-model="employeeStaffName"
              class="form-control"
              readonly
          />
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="form-label mt-1">Ship from (Warehouse)</label>
        <v-select
            placeholder="Select Warehouse Location"
            v-model="locationId"
            :options="locations"
            label="text"
            :reduce="text => text.id"
        />
      </div>
    </div>
    <div class="row content-head">
        <div class="col-lg-2 d-flex justify-content-center align-items-center bg-col-1">
            <input type="text" class="form-control"
                   v-model="barcodeText"
                   id="chat-search"
                   placeholder="Scan" aria-label="Search..."
                   aria-describedby="chat-search"
                   @keydown.enter="onScanBarcode"
                   ref="productScanField"
            />
        </div>

        <div class="col-lg-4 bg-col-2">
            <div class="row grp-pd">
                <div class="col-12 my-1">
                    <AsyncSelect
                        :api-service="fetchProductList"
                        placeholder="Select Product"
                        v-model="selectedProduct"
                        label="text"
                        :format-label="option => option.text"
                        skip-api-on-open
                        ref="productField"
                    />
                </div>
            </div>
        </div>

        <div class="col-lg-6 bg-col-3">
            <div class="table-container padding-right my-1">
                <table class="table">
                    <thead>
                        <tr>
                            <th>SL</th>
                            <th>Item</th>
                            <th class="text-right">Qty</th>
                            <th class="text-right">Price</th>
                            <th class="text-right">Amount</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
    <div class="row content-border">
        <div class="col-lg-2 bg-col-1">
            <div class="group-list content-height">
                <div
                    v-for="(item, index) in parentGroup"
                    :key="item.id"
                    class="group-item"
                    :class="{ active: selectedGroupId === item.id }"
                    @click="selectGroup(item)"
                >
                    <span class="head-group">
                        {{ item.name }}
                    </span>
                </div>
            
            </div>
        </div>

        <div class="col-lg-4 bg-col-2">
            <div class="product-list group-list">
                <div
                    v-for="(item, index) in productList"
                    :key="item.id"
                    class="product-card"
                    @click="addItem(item)"
                >
                    <img
                        :src="item.image || '/app-assets/images/product-photo.png'"
                        class="product-img"
                    />
            
                    <div class="product-name">
                        {{ item.name }}
                    </div>
                
                    <div class="product-meta">
                        <span>Stock: {{ item.stock_in_hand ?? 0 }}</span>
                        <span>MRP: {{ item.sales_price ?? 0 }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 content-height bg-col-3">
            <div class="pos-right">
                <div class="pos-scroll">
                    <div class="table-container table-scroll group-list">
                        <table class="table">
                            <tbody>
                                <tr v-for="(item, index) in data" :key="index">
                                    <th>{{ index+1 }}</th>
                                    <th class="text-overflow">{{ item.name }}</th>
                                    <th class="text-right">
                                        <input
                                            v-model="item.quantity"
                                            name="quantity"
                                            type="number"
                                            class="form-control text-right"
                                            @input="changeQty(item.quantity, index)"
                                        /> 
                                    </th>
                                    <th class="text-right">
                                        <input
                                            v-model="item.rate"
                                            name="quantity"
                                            type="number"
                                            class="form-control text-right"
                                        /> 
                                    </th>
                                    <th class="text-right">
                                        <input
                                            type="text"
                                            class="form-control text-right"
                                            :value="item.rate * item.quantity"
                                            readonly
                                        />
                                    </th>
                                    <th>
                                        <span class="cursor-pointer" @click="deleteTableItem(index)">X</span>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="px-1 cal-border">
                        <div class="row mt-1">
                            <div class="col-lg-4">
                                <label class="text-bold">Sub Total</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Total VAT</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input 
                                    class="form-control text-right"
                                    :value="subTotal + totalVat"
                                    type="number"
                                    readonly
                                >
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold" for="total_amount">Bill Amount</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <input
                                    :value="subTotal"
                                    readonly
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-8">
                                <label class="text-bold">(Less) Round-off / Final Discount</label>
                                <div v-if="discountAmount > 0">
                                    <v-select
                                        placeholder="Select Discount Head"
                                        v-model="formData.discount_head_id"
                                        :options="discountAccHead"
                                        label="name"
                                        :reduce="name => name.id"
                                    />
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountPercent"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                            placeholder="%"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <vField
                                            v-model="discountAmount"
                                            name="total_amount"
                                            type="number"
                                            class="form-control text-right"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                        <div class="row margin-5">
                            <div class="col-lg-4">
                                <label class="text-bold">Net Bill</label>
                            </div>
                            <div class="col-lg-4"></div>
                            <div class="col-lg-4">
                                <vField
                                    :model-value="grandTotal"
                                    @keyup="setDiscountAmount"
                                    name="total_amount"
                                    type="number"
                                    class="form-control text-right"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div @click="openPaymentModal" class="pay-now-btn mb-1">
                    Pay Now
                </div>
            </div>
        </div>
    </div>

    <PaymentModal
        v-if="isPaymentModal"
        :grandTotal="parseFloat(grandTotal)"
        :rewardPointsAccountHeads="rewardPointsAccountHeads"
        :cashAndBank="cashAndBank"
        @close="isPaymentModal = false"
        @onSubmit="submitData"
    />
</template>

<script setup>
import { ref, reactive, watch, onMounted, computed, inject, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import handlePurchase from '@/services/modules/purchase';
import pdfPrinter from '@/services/utils/pdfPrinter';
import handleBarcode from '@/services/modules/barcode';
import figureFormatter from '@/services/utils/figureFormatter';
import handleCompany from '@/services/modules/company';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import PaymentModal from "@/components/molecule/company/sdm/pos-invoice/PaymentModal.vue";
import handleDropdowns from "@/services/modules/dropdowns";
import handleInventory from '@/services/modules/inventory';
import handlePurchaseAndSales from "@/services/modules/purchase";
import hospitalPosPdfPrinter from '@/services/utils/hospitalPosPdfPrinter';
import useInvoiceCalculations from '@/composables/useInvoiceCalculations';
import useDate from "@/services/utils/day";
import handleCompanyContact from "@/services/modules/companyContact";
import handleRole from "@/services/modules/role";
import handleBusinessesLocations from '@/services/modules/businessesLocations'

const props = defineProps({
  items: Array,
  parentGroup: Array,
  contactProfileId: null,
  companyId: null,
  productId: null,
});

const emit = defineEmits(['resetIds']);

const store = useStore();
const route = useRoute();
const router = useRouter();
const date = useDate();
const products = ref([]);
const data = ref([]);
const voucher = ref('');
const companyInfo = ref({});
const cashAndBank = ref([]);
const discountAccHead = ref([]);
const accountRecHead = ref([]);
const totalVat = ref(0);
const isPaymentModal = ref(false);
const productList = ref(false);
const loader = ref(false);
const selectedProduct = ref(null);
const productScanField = ref(null);
const isFromProductScan = ref(false);
const rewardPointsAccountHeads = ref([]);
const productField = ref(null);
const invoiceRes = ref({});
const company = ref({});
const barcodeQuery = ref('');
const barcode = ref('');
const qrcode = ref('');
const customizationPdfFields = ref([]);
const totals = ref({
  subTotalVal: 0,
  totalVatVal: 0,
  totalVal: 0,
})
const dealerRole = ref(null);
const companyRules = ref([])
const dealerIscId = ref(null);
const employeeStaffName = ref(null);
const dealerIscName = ref(null);
const locations = ref([]);
const locationId = ref(null);

const {
  subTotal,
  grandTotal,
  discountAmount,
  discountPercent,
  setDiscountAmount,
  resetDiscounts,
} = useInvoiceCalculations(data, totals)

const barcodeText = ref(null);

const showError = inject("showError");
const showSuccess = inject("showSuccess");

const { fetchProductDropdownList, fetchDropdownList } = handleDropdowns();
const { fetchSalesBill, ...rest } = handlePurchase();
const { fetchProductDetailsByParent } = handleInventory();
const { fetchProductList } = handlePurchaseAndSales();
const { exportToPDF } = pdfPrinter();
const { fetchCompanyInfo, fetchActiveCustomizationField } = handleCompany();
const { formatDate } = figureFormatter();
const { fetchBarcode } = handleBarcode();
const { exportToPDF: exportToPosPDF } = hospitalPosPdfPrinter();
const { fetchContactProfileBySerialNo } = handleCompanyContact();
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchBusinessLocationsList } = handleBusinessesLocations()

const formData = reactive({
  company_id: null,
  contact_profile_id: null,
  referrer_id: null,
  account_head_id: null,
  liability_head_id: null,
  mop_account_head_id: null,
  business_id: null,
  project_id: null,
  cost_centre_id: null,
  location_id: null,
  status: 'active',
  bill_number: '',
  date: '',
  has_item_detail: true,
  description: '',
  order_number: null,
  sales_person_id: null,
  commission_percent: null,
  lc_number: null,
  discount_head_id: null,
  vat_amount: 0,
  sale_type: 'pos_invoice',
  receipt_type: 'pos_invoice',
  receipt_reference: '',
  item_details: [{
    product_id: null,
    name: '',
    description: '',
    quantity: 1,
    rate: 0,
    discount_percent: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
  }]
});

provide('formData', formData);

const getDealerIdByStaffId = () => {
  if (!dealerRole.value){
    showError("Please select Dealer Role")
    return
  }

  let companyQuery = `?company_id=${route.params.companyId}&roles=`+dealerRole.value
  companyQuery += '&serial_no='+dealerIscId.value;
  fetchContactProfileBySerialNo(companyQuery).then(res => {
    if (!res.status) {
      dealerIscName.value = null;
      formData.referrer_id = null;
      employeeStaffName.value = null;
      return showError(res.message)
    }
    formData.referrer_id = res.data.id;
    dealerIscName.value = res.data.full_name;
    formData.contact_profile_id = res.data.contact_owner_id;
    employeeStaffName.value = res.data.contact_owner_name;
  }).catch(err => {
    console.log(err)
  })
}

onMounted(async () => {
    await getLocations();
    if(props.parentGroup.length) {
       await getProductList();
    }
    await getAccountData();
});

watch(locationId, (newVal) => {
  if(newVal) {
    getProductList();
  }
})

const onScanBarcode = async () => {
  if (!barcodeText.value) return;

  const companyQuery = `?company_id=${props.companyId}`;
  const query = `${companyQuery}&barcode_sku=${barcodeText.value}&location_id=${locationId.value}&is_service=1`;

  try {
    loader.value = true;

    const response = await fetchProductDropdownList(query);

    if (!response.status || response.data.length < 1) {
      showError('No product found with this barcode');
      barcodeText.value = null;
      loader.value = false
      return;
    }

    let foundProduct = response.data[0];
    foundProduct.name = response.data[0].text;
    foundProduct.stock_in_hand = response.data[0].stock_in_hand;
    foundProduct.sales_price = response.data[0].description ? response.data[0].description.sales_price : 0;

    isFromProductScan.value = true;
    addItem(foundProduct, 1);

    barcodeText.value = null;

    if (productScanField.value) {
      productScanField.value.focus();
    }
  } catch (e) {
    showError('Failed to fetch product by barcode');
  } finally {
    loader.value = false;
  }
};

const openPaymentModal = () => {
    isPaymentModal.value = true;
}

async function submitData() {
  organizeData();
  const handler = handlePurchase();
  const copyFormData = { ...formData };
  copyFormData.item_details = data.value;
  copyFormData.sale_master_receipt = true;

  try {
    const res = await handler.storeBillPayment(copyFormData);

    if(! res.status ) {
        showError(res.message);
        return;
    }

    showSuccess(res.message)
    goToPrint(res.data.id);
    resetForm();
    isPaymentModal.value = false;
    await getProductList();
  } catch (e) {
    console.log(e);
  }
}

const goToPrint = (id) => {
  const user = store.state.user.user
  const companyQuery = `?company_id=${props.companyId}`;
  const posPrint = customizationPdfFields.value && customizationPdfFields.value.heading_left_pos_print;
  fetchSalesBill(id, companyQuery).then( (res) => {
    if( res ){
      invoiceRes.value = res.data;
      let qrcodeData = JSON.stringify({
        ref_no: invoiceRes.value.bill_number,
        ref_date: invoiceRes.value.date,
        created_by: user.name,
        created_date_time: formatDate(new Date())
      })
      barcodeQuery.value = `?code=${invoiceRes.value.bill_number}&qrcode=${qrcodeData}`;
    }}).then (() => {
    fetchBarcode(barcodeQuery.value).then( (res) => {
      barcode.value = res.barcode;
      qrcode.value = res.qrcode
    }).then( () => {
      if( posPrint ) {
        exportToPosPDF(company.value, invoiceRes.value);
        return;
      }
      exportToPDF(company.value, invoiceRes.value, barcode.value, qrcode.value, user.name, 1)
    })
  }).catch( (e) => {
    console.log("Something went wrong");
  })
}

const selectedGroupId = ref(props.parentGroup.length ? props.parentGroup[0].id : null);

function organizeData() {
  formData.company_id = props.companyId;
  formData.date = date.currentDate();
  formData.location_id = locationId.value;
  formData.adjustment_amount = discountAmount.value;
  data.value = data.value.map(item => ({
    ...item,
    total_amount: (Number(item.rate) || 0) * (Number(item.quantity) || 0),
  }));
}

const getActiveFiledCustomization = async () => {
  const companyQuery = `?company_id=${props.companyId}&customization_type=pdf&type=supershop_pos_pdf`;
  const res = await fetchActiveCustomizationField(companyQuery);
  customizationPdfFields.value = res.data;
};

const addServiceItem = (item, quantity = 1) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.text };

  const newItem = {
    product_id: item.id,
    name: item.text,
    description: '',
    quantity,
    rate: item.description && item.description.sales_price,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand:null,
    product
  };

  data.value.push(newItem);
}

const addItem = (item, quantity = 1) => {
  if (!item) {
    showError('Product not found');
    return;
  }

  if (item.product_type == 'finished_goods' && item.stock_in_hand !== undefined && item.stock_in_hand <= 0) {
    showError('Stock not available');
    return;
  }

  let alreadyExist = false;
  let existingIndex = -1;

  data.value.forEach((el, index) => {
    if (el.product_id === item.id) {
      alreadyExist = true;
      existingIndex = index;
    }
  });

  if (alreadyExist) {
    const existingItem = data.value[existingIndex];

    if (
      item.product_type == 'finished_goods' &&
      item.stock_in_hand !== undefined &&
      existingItem.quantity + quantity > item.stock_in_hand
    ) {
      showError('Stock limit exceeded');
      return;
    }

    existingItem.quantity += quantity;
    changeQty(existingItem.quantity, existingIndex);
    return;
  }

  const product = { name: item.name };

  const newItem = {
    product_id: item.id,
    name: item.name,
    description: '',
    quantity,
    rate: item.sales_price ?? 0,
    discount: 0,
    vat: 0,
    sub_total: 0,
    discount_amount: 0,
    discount_percent: 0,
    vat_amount: 0,
    total: 0,
    is_edit: false,
    stock_in_hand: item.stock_in_hand ?? null,
    product
  };

  data.value.push(newItem);
}

function deleteTableItem(index) {
  data.value.splice(index, 1);
}

const changeQty = (quantity, index) => {
  const item = data.value[index];

  if (!Number.isInteger(Number(quantity)) || quantity <= 0) {
    showError('Quantity must be a positive number');
    item.quantity = 1;
    return;
  }

  if (
    item.product_type == 'finished_goods' &&
    item.stock_in_hand !== null &&
    quantity > item.stock_in_hand
  ) {
    showError('Stock limit exceeded');
    item.quantity = item.stock_in_hand;
    return;
  }

  item.amount = item.rate * quantity;
  item.total_amount = item.rate * quantity;
}

const getLocations = async () => {
  const companyQuery = `?company_id=${route.params.companyId}`
  const locationQuery = `${companyQuery}&location_type=fg_warehouse`;
  const res = await fetchBusinessLocationsList(locationQuery);
  if(!res.status) return;
  locations.value = res.data;
  locationId.value = locations.value[0].id;
}

const getAccountData = async () => {
    const dropdownRes = fetchDropdownList(getDropDownQuery());
    let roleQuery = `?company_id=${route.params.companyId}&roles=dealer,isc`;
    const rolesRes = fetchCompanyDefaultRoles(roleQuery)

    Promise.all([
        dropdownRes.then(res => {
          if(! res.status) return;

          if(res.data.account_head_list_by_slag.accounts_receivable) {
            accountRecHead.value = res.data.account_head_list_by_slag.accounts_receivable;
            formData.account_head_id = res.data.account_head_list_by_slag.accounts_receivable[0].id;
          }
          rolesRes.then(res => {
            if (res.data) companyRules.value = res.data
          })

          if(res.data.account_head_list_by_slag.vat_payable) {
            formData.vat_payable_account_head_id = res.data.account_head_list_by_slag.vat_payable[0].id;
          }

          if(res.data.account_head_list_by_slag.discount_account) {
            discountAccHead.value = res.data.account_head_list_by_slag.discount_account;
          }

          if(res.data.account_head_list_by_slag.cash_and_banks) {
            cashAndBank.value = res.data.account_head_list_by_slag.cash_and_banks;
            formData.mop_account_head_id = cashAndBank.value[0].id;
          }

          if(res.data.account_head_list_by_slag.reward_points) {
            rewardPointsAccountHeads.value = res.data.account_head_list_by_slag.reward_points;
          }
        }),
        fetchCompanyInfo(props.companyId).then(res=> {
          if(res.data) company.value = res.data;
        }),
        getActiveFiledCustomization()
    ]).finally(() => {loader.value=false})
}

const getDropDownQuery = () => {
  let query = `?company_id=${props.companyId}
    &is_account_heads=1
    &slags[]=discount_account
    &slags[]=reward_points
    &slags[]=vat_payable
    &slags[]=accounts_receivable
    &slags[]=cash_and_banks`;
                
  return query;
}

function resetForm() {
  data.value = [];
  discountAmount.value = 0;
  discountPercent.value = 0;
  dealerRole.value = null;
  dealerIscId.value = null;
  employeeStaffName.value = null;
  dealerIscName.value = null;
  Object.assign(formData, {
    ...formData,
    company_id: props.companyId,
    contact_profile_id: null,
    liability_head_id: null,
    account_head_id: accountRecHead.value[0].id,
    mop_account_head_id: cashAndBank.value[0].id,
    business_id: null,
    project_id: null,
    cost_centre_id: null,
    location_id: null,
    status: 'active',
    bill_number: '',
    date: '',
    has_item_detail: true,
    description: '',
    order_number: null,
    sales_person_id: null,
    commission_percent: null,
    lc_number: null,
    discount_amount: 0,
    discount_percent: 0,
    discount_head_id: discountAccHead.value[0].id,
    vat_amount: 0,
    payment: 0,
    points_redeemed: 0,
    sale_type: 'pos_invoice',
    receipt_type: 'pos_invoice',
    item_details: [{
      product_id: null,
      name: '',
      description: '',
      quantity: 1,
      rate: 0,
      discount_percent: 0,
      vat: 0,
      sub_total: 0,
      discount_amount: 0,
      vat_amount: 0,
      total: 0,
      is_edit: false,
    }]
  });
  resetDiscounts();
}

const selectGroup = (item) => {
    selectedGroupId.value = item.id;
}

const getProductList = async () => {
    const query = `?company_id=${props.companyId}&location_id=${locationId.value}`;

    try{
        const res = await fetchProductDetailsByParent(query, selectedGroupId.value);
        
        if(! res.status) {
            return showError('Product Not found');
        }
        productList.value = res.data;
    }catch(e){
        console.log(e);
    }
    loader.value = false
}

watch(selectedGroupId, (newVal) => {
    if(newVal) {
        getProductList();
    }
})

watch(selectedProduct, async (newProduct) => {
    if (!newProduct) return;

    if (newProduct.product_type !== "services"){
      const res = await rest.fetchProductById(newProduct.id, `?company_id=${props.companyId}&location_id=${locationId.value}`);
      if(!res.status) return showError('Product not found');
      addItem(res.data, 1);
    }

    if (newProduct.product_type === "services") {
       addServiceItem(newProduct, 1);
    }
    
    selectedProduct.value = null;
    productField.value.clear();
});

watch(discountAmount, (newValue) => {
  if(newValue > 0 && discountAccHead.value.length > 0) {
    formData.discount_head_id = discountAccHead.value[0].id;
    formData.adjustment_amount = discountAmount.value;
  }
})
</script>

<style scoped>
.group-list {
    overflow-y: auto;
    overflow-x: hidden;
}
.content-head {
    margin-left: 1px;
    margin-right: 1px;
}
.content-height {
    height: 620px;
}

.padding-right {
    padding-right: 3rem;
}

.group-list::-webkit-scrollbar {
    width: 4px;
}

.group-list::-webkit-scrollbar-track {
    background: transparent;
}

.group-list::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 10px;
}

.group-head {
    background: #5286d4;
    color: #fff;
}

.grp-pd {
    padding: 2px 0px;
}

.group-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 12px 14px;
    margin: 8px 2px;
    cursor: pointer;

    display: flex;
    align-items: center;

    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    transition: all 0.2s ease;
}

.group-item:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
    transform: translateY(-1px);
    background: #f3f2f7;
}

.group-item.active {
    background: #7367f0; /* Vuexy primary */
    color: #fff;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 1.4);
}

.group-item.active .head-group {
    color: #fff;
}

.head-group {
    display: block;

    font-size: 24px;
    text-align: center;
    line-height: 80px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-list {
    height: 620px;                /* match group-list */
    overflow-y: auto;
    padding: 6px;

    display: grid;
    grid-template-columns: repeat(1, 1fr); /* 2 columns like image */
    gap: 6px;
    align-content: flex-start;
}

/* PRODUCT CARD */
.product-card {
    min-height: 80px;
    padding: 6px;
    cursor: pointer;
    background: #fff;

    display: grid;
    grid-template-columns: 50px 1fr;
    grid-template-rows: auto auto;
    column-gap: 6px;
    border-radius: 12px;
    padding: 12px;
    margin: 3px;
    transition: all 0.2s ease;

    /* NO BORDER */
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.product-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    background: #f3f2f7;
}

/* IMAGE */
.product-img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    grid-row: 1 / span 2;
}

/* NAME */
.product-name {
    font-weight: 620;
    font-size: 13px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* MRP + STOCK */
.product-meta {
    font-size: 11px;
    display: flex;
    justify-content: space-between;
}

.table-scroll {
    height: 300px !important;
}

.margin-5 {
    margin-top: 5px;
}

.content-border {
    margin-left: 1px;
    margin-right: 1px;
}
.pay-now-btn {
    background: #7367f0;
    color: #fff;
    font-weight: bold;
    text-align: center;
    padding: 10px;
    cursor: pointer;
    font-size: 20px;
    border-radius: 10px;
}

.pos-right {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.pos-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

.cal-border {
    border-top: 3px solid;
}

.bg-col-1 {
    background-color: rgba(115, 103, 240, 0.12);
    padding-right: 0px;
}

.bg-col-2 {
    background-color: rgba(40, 199, 111, 0.12);
}

.bg-col-3 {
    background-color: rgba(255, 159, 67, 0.12);
}

.table {
  table-layout: fixed;
  width: 100%;
}

.table th:nth-child(1),
.table td:nth-child(1) {
  width: 8%;
}

.table th:nth-child(2),
.table td:nth-child(2) {
  width: 45%; /* ITEM → BIG */
}

.table th:nth-child(3),
.table td:nth-child(3),
.table th:nth-child(4),
.table td:nth-child(4),
.table th:nth-child(5),
.table td:nth-child(5) {
  width: 15%; /* Qty, Price, Amount */
}

.table th:nth-child(6),
.table td:nth-child(6) {
  width: 5%; /* delete */
}
</style>